/**
 * GoHire Avatar Color Palette - Soft pastel backgrounds for enterprise look
 * Uses hash of name to consistently assign same color to same person
 */
const avatarPastelColors = [
  { bg: '#E8F5E9', ring: '#43A047' }, // Green
  { bg: '#E0F2F1', ring: '#00897B' }, // Teal
  { bg: '#E3F2FD', ring: '#1E88E5' }, // Blue
  { bg: '#E8EAF6', ring: '#5C6BC0' }, // Indigo
  { bg: '#F3E5F5', ring: '#8E24AA' }, // Purple
  { bg: '#FFF3E0', ring: '#FB8C00' }, // Orange
  { bg: '#FFFDE7', ring: '#FDD835' }, // Yellow
  { bg: '#FFEBEE', ring: '#E53935' }, // Red
];

// Dark text color for initials
export const avatarInitialsColor = '#263238';

/**
 * List of available preset avatar names
 */
export const avatarPresetNames = [
  'bear', 'cat', 'cow', 'dog', 'elephant', 'fox',
  'frog', 'giraffe', 'horse', 'koala', 'lion', 'monkey',
  'otter', 'owl', 'panda', 'penguin', 'pig', 'rabbit',
  'seal', 'sheep', 'shiba', 'tiger', 'walrus', 'wolf'
];

/**
 * Get SVG source for a preset avatar name
 * This handles webpack hashing by re-importing via require if needed
 */
export const getPresetAvatarSrc = (nameOrUrl) => {
  if (!nameOrUrl) return null;
  
  // If it's already a full data URL or external URL, return it
  if (nameOrUrl.startsWith('data:') || nameOrUrl.startsWith('http') || nameOrUrl.startsWith('/')) {
    return nameOrUrl;
  }

  // Check if the string is one of our preset names
  if (avatarPresetNames.includes(nameOrUrl)) {
    try {
      // Use relative path from this utility to assets
      const imported = require(`../assets/avatars/${nameOrUrl}.svg`);
      return typeof imported === 'string' ? imported : imported.default || imported;
    } catch (e) {
      console.warn(`Failed to resolve avatar preset: ${nameOrUrl}`, e);
      return null;
    }
  }

  return nameOrUrl;
};

/**
 * Simple hash function to convert a string to a consistent number
 */
export const hashString = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
};

/**
 * Get pastel background color for avatar based on name
 * Same person always gets same color
 */
export const getAvatarColor = (name) => {
  if (!name || !name.length) {
    return avatarPastelColors[0].bg;
  }
  const index = hashString(name) % avatarPastelColors.length;
  return avatarPastelColors[index].bg;
};

/**
 * Get matching ring/border color for avatar based on name
 * Same person always gets same color
 */
export const getAvatarRingColor = (name) => {
  if (!name || !name.length) {
    return avatarPastelColors[0].ring;
  }
  const index = hashString(name) % avatarPastelColors.length;
  return avatarPastelColors[index].ring;
};

export const getInitials = (name) => {
  if (!name || !name.length) {
    return "";
  }

  const nameParts = name.trim().split(" ");

  if (nameParts.length === 1) {
    return nameParts[0].charAt(0).toUpperCase();
  } else {
    const firstNameInitial = nameParts[0].charAt(0).toUpperCase();
    const lastNameInitial = nameParts[nameParts.length - 1]
      .charAt(0)
      .toUpperCase();
    return firstNameInitial + lastNameInitial;
  }
};
